<template>
  <a-modal
    :visible="modalVis"
    title="Closing UM by Authorized"
    :width="500"
    centered
    :closable="false"
    :maskClosable="false"
  >
    <template slot="footer">
      <a-button @click="handleClose()">Cancel</a-button>
      <a-button type="primary" @click="handleModalClosing()" :loading="loadingmodalcloseUM">Process</a-button>
    </template>
    
    <a-form-model
      ref="closingForm"
      :model="DataClosing"
      :rules="DataClosingRules"
    >
      <a-form-model-item label="Note" prop="note"
        :label-col="{ span:100 }" :wrapper-col="{ span: 100 }">
        <a-textarea v-model="DataClosing.note" class="m-width-full"/>
      </a-form-model-item>
      <div class="m-price-total">
          <div class="m-display-flex flex-row space-between nowrap">
            <span>Value Transaction</span>
            <span>{{formatCurrency("IDR",DataClosing.value)}}</span>
          </div>
      </div>
      <a-divider class="margin-small">Document Support</a-divider>
      <!-- <a-form-model-item label="id_um" prop="id_um" hidden 
      :label-col="{ span: 10 }" :wrapper-col="{ span: 10 }">
        <a-input v-model="DataClosing.id_um" disabled />
      </a-form-model-item>
      <a-form-model-item label="No" prop="no"
        :label-col="{ span:100 }" :wrapper-col="{ span: 100 }">
        <a-input v-model="DataClosing.no" disabled class="m-width-full"/>
      </a-form-model-item>
      <a-form-model-item label="Description" prop="description"
        :label-col="{ span:100 }" :wrapper-col="{ span: 100 }">
        <a-textarea v-model="DataClosing.description" disabled class="m-width-full"/>
      </a-form-model-item>
      <a-form-model-item label="Value" prop="value"
        :label-col="{ span:100 }" :wrapper-col="{ span: 100 }" hidden>
        <a-input-number v-model="DataClosing.value" disabled class="m-width-full"/>
      </a-form-model-item>
      <a-form-model-item label="Value" prop="value2"
        :label-col="{ span:100 }" :wrapper-col="{ span: 100 }">
        <a-input v-model="DataClosing.value2" disabled class="m-width-full"/>
      </a-form-model-item> -->

      <a-form-model-item label="Document Name" prop="doc_name" 
      :label-col="{ span:100 }" :wrapper-col="{ span: 100 }">
        <a-input v-model="DataClosing.doc_name" />
      </a-form-model-item>
      <a-form-model-item label="Upload File" prop="attachment" 
      :label-col="{ span:100 }" :wrapper-col="{ span: 100 }">
        <a-upload
                :showUploadList="false"
                v-model="DataClosing.attachment"
                :beforeUpload="beforeUpload"
        >
          <a-button type="primary"> <a-icon type="upload" />Select File + Add</a-button>
        </a-upload>
      </a-form-model-item>
    </a-form-model>
    <a-list
      bordered
      :dataSource="doc_attachment"
      class="doc-viewer edit"
      size="small"
    >
      <a-list-item slot="renderItem" slot-scope="item, index">
        <a-list-item-meta>
          <div slot="description">
            <div class="m-display-flex space-between align-middle">
              <div><b>{{index+1}}. {{item.name}}</b><br/>
              <span>{{item.file.name}}</span></div>
              <a-button icon="delete" type="danger" @click="handleRemove(item.name)"></a-button>
            </div>
          </div>
        </a-list-item-meta>
      </a-list-item>
      <!-- <div slot="header">Header</div>
      <div slot="footer">Footer</div> -->
    </a-list>
      <!-- <div v-for="(item,index) in DataClosing.doc_attachment" :key="index">
        ok
        <a-button
          type="danger"
          ghost
          size="small"
          class="close"
          icon="close"
          @click="removeUploadFile()"
        ></a-button>
        <div class="detail">
          <h4 class="margin-remove m-text-dots">
            {{
              JSON.parse(
                JSON.stringify(item.name)
              )
            }}
          </h4>
        </div>
      </div> -->
  </a-modal>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import axios from "axios";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import _ from "lodash";

export default {
  name: "modalClosingUM",
  props: {
    modalVis: Boolean,
    DataClosing: {},
    docList: {},
  },
  mixins: [CurrencyFormat],
  computed: {
    ...mapGetters(["getDefaultDateFormat", "getAuth", "getScreen"]),
  },
  data() {
    return {
      loadingmodalcloseUM: false,
      DataClosingRules:{
        note: {
          required: false,
          message: "please input Note!",
          trigger: "blur",
        },
      },
      doc_attachment:[],
    };
  },
  mounted(){
  },
  beforeCreate() {
  },
  methods: {
    moment,
    handleModalClosing() {
      //this.confirmMessageValue("confirm-save", null, null);
      const that = this;
      //this.$refs.closingForm.validate((valid) => {
        if (this.DataClosing.note==null || this.DataClosing.note.trim()=="") {
          this.displayMessageValue(
            "error-other",
            "Note Can't be empty!"
          );
          return;
        }

        if(this.doc_attachment.length==0){
          this.displayMessageValue(
            "error-other",
            "File Upload Can't be empty!"
          );
          return;
        }


        let data = new FormData(); 
        data.append("tlc", this.getAuth.username);
        data.append("note", this.DataClosing.note);

        this.DataClosing.list.forEach((record, index) => {
          data.append(`id_um[${index}]`, record.id_um);
        });

        this.doc_attachment.forEach((record, index) => {
          data.append(`document_name[${index}]`, record.name);
          data.append(`upload_file[${index}]`, record.file);
        });
        
        that.loadingmodalcloseUM = true;
        this.$store
        .dispatch("postClosingUM", {
          auth: this.getAuth,
          data, 
        })
        .then((res) => {
          this.displayMessageValue("successClose", res.message);
          //this.$router.go();
          Event.$emit("handlemodalClose", false);
          that.loadingmodalcloseUM = false;
          Event.$emit("handlesuccessClose", false);
        })
        .catch((error) => {
          let response = Object.assign({}, error.response);
          if (response.status) {
            this.displayMessageValue("error-other", response.message);
          } else {
            //this.displayMessageValue("error-other", error);
            this.displayMessageValue("error", error.message);
          }
          that.loadingmodalcloseUM = false;
        });
      //});
    },
    handleClose() {
      this.doc_attachment = [];
      Event.$emit("handlemodalClose", false);
    },
    handleRemove(name){
      this.doc_attachment = _.filter(this.doc_attachment, (item) => item.name.toLowerCase()!=name.toLowerCase());
    },
    beforeUpload(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 5) {
        this.displayMessage("large-file-5mb");
      } else {
        let nam = this.DataClosing.doc_name.toLowerCase();
        let existAttachment =  _.filter(this.doc_attachment, (item) => item.name.toLowerCase()===nam.toLowerCase());
        if(this.DataClosing.doc_name==null || this.DataClosing.doc_name=="" ){
          this.displayMessageValue("error-other", "Document Name Can't be Empty!");
        }else if (existAttachment.length>0){
          this.displayMessageValue("error-other", "Document Name is already exist!");
        }else{
          this.doc_attachment.push({
            name: this.DataClosing.doc_name,
            file: file,
          });
          this.DataClosing.pushFile=[];
          this.DataClosing.doc_name="";
        }
        return false;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.doc-viewer {
  margin-top: 0.5em;
  border: 1px solid darken(white, 10);
  padding: 5px 0;
  min-height: 50px;
  display: flex;
  align-items: flex-end;
  gap: 12px;
  background-color: darken(white, 2);
  position: relative;

  &.edit {
    align-items: center;
    padding: 5px;
    min-height: auto;
    .detail {
      flex: 1;
      flex-direction: row;
      justify-content: space-between;
      h4 {
        text-align: right;
      }

      &.mobile {
        flex-direction: column;
        justify-content: flex-start;
        gap: @padding / 2;
        h4 {
          text-align: left;
        }
      }
    }
  }

  .icon {
    font-size: 3.5em;
    color: orangered;
  }

  .detail {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    line-height: 1.5em;
  }

  .close {
    position: absolute;
    top: 5px;
    right: 5px;
  }
}
</style>
